import React from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useCompetencyMatchingContext } from "@/contexts/competencyMatchingContext";
import { CustomSelect } from "Components/Common/CustomSelect";

export const SourceSelection = () => {
    const {
        sourceOptions,
        categoryOptions,
        categoriesLoading,
        standardCategoryOptions,
        standardsCategoriesLoading,
        selectedSource,
        selectedCategory,
        selectedStandardCategory,
        setSelectedSource,
        setSelectedCategory,
        setSelectedStandardCategory,
        handleNextStep
    } = useCompetencyMatchingContext();

    return (
        <div className="source-selection">
            <label className="section-title">Select the source</label>
            <Form className="source-selection-form">
                <Form.Group className="form-group">
                    <CustomSelect
                        options={sourceOptions}
                        value={sourceOptions.find(
                            (option) => option.value === selectedSource
                        )}
                        onChange={(value: string) => {
                            setSelectedSource(value);
                            setSelectedCategory("");
                            setSelectedStandardCategory("");
                        }}
                        placeholder="Select an option"
                    />
                </Form.Group>

                <label className="section-title">Select the categories</label>

                <Form.Group>
                    <Form.Label>Your category {categoriesLoading && <Spinner animation="border" size="sm" />}</Form.Label>
                    <CustomSelect
                        options={categoryOptions}
                        value={categoryOptions.find(
                            (option) => option.value === selectedCategory
                        )}
                        onChange={(value) => setSelectedCategory(value)}
                        placeholder="Your category"
                        isDisabled={selectedSource === ""}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>Standard category {standardsCategoriesLoading && <Spinner animation="border" size="sm" />}</Form.Label>
                    <CustomSelect
                        options={standardCategoryOptions}
                        value={standardCategoryOptions.find(
                            (option) =>
                                option.value === selectedStandardCategory
                        )}
                        onChange={(value) => setSelectedStandardCategory(value)}
                        placeholder="Standard category"
                        isDisabled={selectedCategory === ""}
                    />
                </Form.Group>

                <div className="form-actions form-actions--matching">
                    <Button
                        variant="primary"
                        className="btn-continue"
                        onClick={handleNextStep}
                        disabled={!selectedSource || !selectedCategory || !selectedStandardCategory}
                    >
                        Continue
                    </Button>
                </div>
            </Form>
        </div>
    );
};
